import { ApiConfig } from "../../Config/ApiConfig";
import { createPostDataAction } from "./CommonAction";
import {
  SUBSCRIPTION_PLAN_LIST,
  SUBSCRIPTION_PLAN_DETAILS,
  SUBSCRIPTION_PLAN_UPDATE,
} from "../../Constants/SubscriptionPlanConstants";

export const SubscriptionPlanListAction = (payload: any) =>
  createPostDataAction(SUBSCRIPTION_PLAN_LIST, ApiConfig.SubscriptionPlanList, payload, false);

export const SubscriptionPlanDetailsAction = (payload: any) =>
  createPostDataAction(
    SUBSCRIPTION_PLAN_DETAILS,
    ApiConfig.SubscriptionPlanDetail,
    payload,
    false,
  );

export const SubscriptionPlanUpdateAction = (payload: any) =>
  createPostDataAction(
    SUBSCRIPTION_PLAN_UPDATE,
    ApiConfig.SubscriptionPlanUpdate,
    payload,
    true,
  );
